export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=template&id=042f950b&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/pages/lk/requests/index.vue?vue&type=template&id=042f950b&
// module id = 1388
// module chunks = 0